import React, { useState } from 'react';
import { Link } from 'react-scroll';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToForm = () => {
    document.getElementById('form-section').scrollIntoView({ 
      behavior: 'smooth' 
    });
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="header__container container">
        <div className="header__logo">
          <Link 
            to="hero" 
            smooth={true} 
            duration={500}
            className="header__logo-link"
          >
            <img 
              src="/images/horizontalbranco.png" 
              alt="Nukard - Soluções Digitais" 
              className="header__logo-img"
            />
          </Link>
        </div>

        <nav className={`header__nav ${isMobileMenuOpen ? 'header__nav--open' : ''}`}>
          <Link 
            to="benefits" 
            smooth={true} 
            duration={500}
            className="header__nav-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Benefícios
          </Link>
          <Link 
            to="solutions" 
            smooth={true} 
            duration={500}
            className="header__nav-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Soluções
          </Link>
          <Link 
            to="form-section" 
            smooth={true} 
            duration={500}
            className="header__nav-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Contato
          </Link>
        </nav>

        <div className="header__actions">
          <button 
            onClick={scrollToForm}
            className="btn btn-primary header__cta"
          >
            <svg 
              width="21" 
              height="21" 
              viewBox="0 0 24 24" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* Corpo principal da lâmpada */}
              <path 
                d="M12 2C8.13 2 5 5.13 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.13 15.87 2 12 2Z" 
                fill="currentColor"
                className="bulb-body"
              />
              {/* Base da lâmpada */}
              <path 
                d="M9 21V20C9 19.45 9.45 19 10 19H14C14.55 19 15 19.45 15 20V21C15 21.55 14.55 22 14 22H10C9.45 22 9 21.55 9 21Z" 
                fill="currentColor"
                className="bulb-base"
              />
              {/* Filamentos internos */}
              <path 
                d="M11 10V12" 
                stroke="white" 
                strokeWidth="1.5" 
                strokeLinecap="round"
                className="filament"
              />
              <path 
                d="M10 8L12 10L14 8" 
                stroke="white" 
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                className="filament"
              />
              {/* Brilho central */}
              <circle 
                cx="12" 
                cy="9" 
                r="0.8" 
                fill="white" 
                opacity="0.3"
                className="inner-glow"
              />
              {/* Raios de luz (aparecem no hover) */}
              <g className="light-rays" opacity="0">
                <path d="M12 1V3" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M20.5 9H18.5" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M5.5 9H3.5" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M18.36 3.64L17.07 4.93" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round"/>
                <path d="M6.93 4.93L5.64 3.64" stroke="#FFD700" strokeWidth="1.5" strokeLinecap="round"/>
              </g>
            </svg>
            Dê vida à sua ideia digital
          </button>
          
          <button 
            className={`header__mobile-toggle ${isMobileMenuOpen ? 'header__mobile-toggle--open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 